import { SelectableMenuItem, MenuItem } from '@/models';

export const sortItemsByDeliveryEligiblity = (a: SelectableMenuItem<MenuItem, MenuItem>, b: SelectableMenuItem<MenuItem, MenuItem>) =>
  (a.item.eligibleForDelivery && b.item.eligibleForDelivery) || (!a.item.eligibleForDelivery && !b.item.eligibleForDelivery) ? 0 : a.item.eligibleForDelivery ? -1 : 1;
